export enum NodeEnv {
  Development = 'development',
  Production = 'production',
}

export enum AttachmentTypeEnum {
  BusinessCertificate = 1, //İşletme Belgesi
  OfficialLetter = 2, //Resmi Yazı
  OtherDocument = 3, //Diğer Sertifika ve Belgeler
  HotelImage = 4, // Tesis Görseli
  HotelClosureDocument = 5, // Tesis Kapalılık Belgesi
  AuditCompanyLogo = 6, // Denetim firması logo
  DenunciationAttachment = 7,
  RestaurantImageAttachment = 8, //Restoran Görseli
  RestaurantClosureDocument = 9, //Restoran Kapalılık Belgesi
  InspectionReportAttachment = 10,
  SignatureAuditReportAttachment = 11,
  VisualEvidenceAttachment = 12,
  CapacityDeclarationAttachment = 13, // Kapasite Beyanı Belgesi
  ConsentLetter = 14, // Muvafakatname
  SurveillanceReport1AttachmentList = 15, // 1. Gözetim Belgesi
  SurveillanceReport2AttachmentList = 16, // 2. Gözetim Belgesi
  InspectionReportAttachment2 = 17, // Yerinde Denetim Tutanağı 2
  SignatureAuditReportAttachment2 = 18, // İmza/Kaşeli Denetim Raporu 2"
  VisualEvidenceAttachment2 = 19, // Denetim Görsel Kanıtlar 2
}

export enum CookieName {
  Language = 'gc-lang',
  Token = 'gc-tk',
  UserInformation = 'gc-ui',
  UserPermission = 'gc-per',
  UserSpecialPermission = 'gc-spe-per',
}
export enum statusEnum {
  Published = 1, //Yayında
  WaitingForApproval = 2, //Onay Bekleniyor
  Approved = 3, // Onaylandı
  Rejected = 4, // Reddedildi
  Deleted = 8, // Silindi
  WaitingForSmsApproval = 100, //Sms Onayı Bekliyor
  SmsApproval = 101, //Sms Onaylandı
  Drafted = 200, //Taslak
}

export enum userTypeEnum {
  SuperAdmin = 1,
  CallCenter = 2,
  AuditCompanyAdmin = 3,
  AuditCompanyPerson = 4,
  CompanyAdmin = 5,
  CompanyUser = 6,
  TgaAdmin = 7,
  GreenWebSiteUser = 8,
  ContentApprovalTeam = 9,
  IKTMUser = 10,
  CFPUser = 11,
  VisualContentEditor = 12,
}

export enum operationTypeEnum {
  Create = 1,
  Update = 2,
  Delete = 3,
  UserLogin = 4,
}

export enum roomCountEnum {
  All = 0,
  UnderThirty = 1,
  UpperThirty = 2,
  UpToFifty = 3,
}

export enum documentStatusEnum {
  Var = 1,
  Yok = 0,
}

export enum hotelCertificateStatusEnum {
  All = 0,
  CertificationProcess = 300,
  CertificateApprovedStage1 = 301,
  Certified = 302,
  NotConsideredAppropriate = 303,
  LeftTheProcess = 304,
  Expired = 305,
  CertificateApprovedStage2 = 306,
  DismissalFromProbation = 308,
  NewMember = 606,
  AuditFirmContracted = 607,
}
export enum iktmStatus {
  All = 0,
  CertificationProcess = 300,
  CertificateApprovedStage1 = 301,
  Certified = 302,
  NotConsideredAppropriate = 303,
  LeftTheProcess = 304,
  Expired = 305,
  CertificateApprovedStage2 = 306,
  UnCertified = 307,
}

export enum userStatusEnum {
  WaitingForApproval = 2,
  Approved = 3,
  Rejected = 4,
  WaitingForSmsApproval = 100,
  SmsApproval = 101,
}

export enum auditStatusEnum {
  RequestCanBeSent = 400,
  RequestCanNotBeSent = 401,
  RequestSend = 402,
}

export enum SupervisionStatusEnum {
  InitialCheckCompleted = 1, // Açılış denetimi tamamlandı
  FirstSupervisionPending = 2, // 1. Gözetim bekleniyor.
  FirstSupervisionCompleted = 3, // 1. Gözetim tamamlandı.
  FirstSupervisionNotCompleted = 4, // 1. Gözetim tamamlanamadı.
  SecondSupervisionPending = 5, // 2. Gözetim bekleniyor.
  SecondSupervisionCompleted = 6, // 2. Gözetim tamamlandı.
  SecondSupervisionNotCompleted = 7, // 2. Gözetim tamamlanamadı.
}

export enum approvalAuditStatusEnum {
  WaitingForApproval = 2,
  Approved = 3,
  Rejected = 4,
  Canceled = 9,
  AutoCanceled = 10,
  Expired = 305,
  RevisionRequested = 600,
  RequestSent = 402,
}

export enum auditResultEnum {
  Documented = 1,
  Undocumented = 2,
  Certificated = 3,
}
export enum InProgressStateInfoEnum {
  Stage1ProgressInfo = 1,
  Stage2ProgressInfo = 2,
  CertificateProgressInfo = 3,
}

export enum ReportPageTypes {
  CertificationProcessCompletedList = 'certification-process-completed-list',
  CertificationInProgressList = 'certification-in-progress-list',
  ApplicationAuditRejectList = 'application-audit-reject-list',
  ApplicationAuditWaitingForApprovalList = 'application-audit-waiting-for-approval-list',
  AuditApproveAndCertificateNotStartedHotelList = 'audit-approve-and-certificate-not-started-hotel-list',
  CertificateNotAppropriateList = 'certificate-not-appropriate-list',
  NotForwardedSmsHotelList = 'not-forwarded-sms-hotel-list',
  AuditApprovedHotelList = 'audit-approved-hotel-list',
}

export enum ReportPageColors {
  CertificationProcessCompletedList = '#FF9C2B',
  CertificationInProgressList = '#5D5FEF',
  ApplicationAuditRejectList = '#01BACA',
  ApplicationAuditWaitingForApprovalList = '#F178B6',
  AuditApproveAndCertificateNotStartedHotelList = '#8BBC21',
  CertificateNotAppropriateList = '#7249A4',
  NotForwardedSmsHotelList = '#492970',
  AuditApprovedHotelList = '#7D0D0D',
}

export enum isReadEnum {
  All = 0,
  Read = 1,
  Unread = 2,
}

export enum NotificationTypeFilterEnum {
  CreateHotel = 1,
  UpdateHotel = 2,
  CreateHotelCertificate = 3,
  UpdateHotelCertificate = 4,
  CreateUser = 5,
}

export enum ImageStatusFilterEnum {
  All = 0,
  WaitingForApproval = 2,
  Rejected = 4,
}

export enum ConsentLetterStatusFilterEnum {
  All = 0,
  WaitingForApproval = 2,
  Approved = 3,
  Rejected = 4,
}
export enum hotelRevisedEnum {
  RevisedRequested = 600,
  RevisedCompletelyDone = 601,
  RevisedRejected = 602,
  RevisedPartiallyDone = 603,
  RevisedNotRequested = 604,
  RevisedRequestedBySuperAdmin = 605,
  ReviseRetreated = 606,
}
export enum hotelRevisedStatusEnum {
  Approve = 1,
  Reject = 2,
}

export enum RegistrationStatusEnum {
  Registered = 1,
  Deleted = 8,
}
